import React from "react";
import { Typography } from "antd";
import { setActiveEvent } from "../../features/plan/PlanSlice";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import Walkthrough from "./Walkthrough";
import EmployeeDetails from "./EmployeeDetails";
import EmployeeWage from "./EmployeeWage";
import ProviderTariffSelector from "./ProviderTariffSelector";
import OncallSelector from "./OncallSelector";
const { Title } = Typography;

const ViewEventDetails = (props) => {
  const {
    activeEvent,
    title,
    type,
    changeActiveEvent,
    onTariffChanged,
    onUseEmployeeTariffChanged,
    onTransportationChanged,
    orders,
  } = props;
  const dispatch = useDispatch();

  const onSelectProviderTariff = (val) => {
    if (type === "scheduling") {
      changeActiveEvent({ ...activeEvent, client_tariff_id: val });
    } else {
      dispatch(setActiveEvent({ ...activeEvent, client_tariff_id: val }));
    }
  };

  const onOncallChange = (val) => {
    changeActiveEvent({ ...activeEvent, oncall: val });
  };

  return (
    <div className="details-slide">
      <div className="details scheduling">
        <div className="main">
          <Title level={2}>{title}</Title>
          <EmployeeDetails activeEvent={activeEvent} />
          <EmployeeWage
            readonly={true}
            activeEvent={activeEvent}
            onTariffChanged={onTariffChanged}
            onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
            onTransportationChanged={onTransportationChanged}
            onOncallChange={onOncallChange}
          />
          <OncallSelector
            onOncallChange={onOncallChange}
            activeEvent={activeEvent}
            readonly={true}
          />
          <Title level={4}>
            {<FormattedMessage id="app.scheduling.selectProviderTariff" />}
          </Title>
          <ProviderTariffSelector
            readonly={true}
            activeEvent={activeEvent}
            onSelectProviderTariff={onSelectProviderTariff}
          />
        </div>
      </div>

      <Walkthrough activeEvent={activeEvent} orders={orders} type={type} />
    </div>
  );
};

export default ViewEventDetails;
